export default __webpack_public_path__ + "static/media/Housekeeping.00b7a646.png";